/* =========================================================
   Kent Dubs – kd-customiser.js (MASTER – PRESTIGE SAFE)
   - Single source of truth
   - LED Upgrade rules
   - Eye design Blank hides Eye colour (and clears selection)
   - ATC validation
   - Reorder UI: LED + Insulation above Cover colour
   - Apply tile data-name from image alt
   - Eye Design Upgrade (priced hidden product) via /cart/add.js intercept (Prestige-safe)
     ✅ preserves Prestige "sections" response using FormData items[][...]
   - Tile click fix: native click on underlying radio + immediate UI refresh
   - ✅ Add-ons (hidden product variants) + metafield gating + snorkel OS/NS exclusivity
   - ✅ Add-on tile images pulled from hidden add-ons product variant images
   - ✅ LIVE PRICE + BREAKDOWN + ADD-ON TILE PRICES (base + hidden add-ons + upgrade)
   - ✅ FAST TRACK (SHOP LEAD TIME): checkbox UI + hidden variant added to cart + included in breakdown + disables when sold out
   - ✅ Supports day use dropdown metafield gating (default off unless enabled)
   - ✅ LEAD TIME snapshot saved to order properties at Add-to-Cart time
   - ✅ FIX: aria-checked sync so ticks/borders show on ALL add-on tiles
   - ✅ FIX: hide "No snorkel" tile
   - ✅ FIX: snorkel tiles match add-ons tile sizing/styling (JS-injected CSS + height normalize)
   - ✅ FIX: DO NOT gate add-ons if window.KD_PRODUCT_META is missing (prevents random hiding)
   - ✅ PERSONALISATION (per letter): adds Screen Cover Add-on variant with qty = letters
     ✅ stores name + font on MAIN line item properties
     ✅ included in live price breakdown

   ✅ PRICING CLARITY UX (NEW)
   - Adds "From (cover only)" context label next to base price
   - Live price label changed to "Total with selected options"
   - Breakdown first line clarified: "Base cover (cover only)"
   - Adds small transparency note to avoid “trick” perception
   ========================================================= */

(function () {
  'use strict';

  console.log('[KD] kd-customiser (prestige safe) loaded');

  const KD_STRINGS = { ...window.themeVariables?.strings, ...window.KD_THEME_STRINGS };
  function kdT(key, fallback, vars = {}) {
    let text = KD_STRINGS[key] || fallback || '';
    Object.entries(vars).forEach(([name, value]) => {
      text = String(text).replace(new RegExp(`{{\\s*${name}\\s*}}`, 'g'), String(value));
    });
    return text;
  }

  const CFG = {
    legends: {
      cover: 'Cover colour',
      eyeDesign: 'Eye design',
      eyeColour: 'Eye colour',
      insulation: 'Insulation',
      led: 'LED'
    },
    values: {
      thermal: 'Thermal',
      ledUpgrade: 'LED Upgrade',
      noLed: 'No LED',
      coverBlack: 'Black',
      eyeBlank: 'Blank'
    },
    propCover: 'properties[Cover colour]',
    propEyeDesign: 'properties[Eye design]',
    propEyeColour: 'properties[Eye colour]',
    kdEyesWrapSelector: '#kd-eyes',
    formSelector: 'form[action^="/cart/add"]',

    // ✅ Pricing clarity labels
    basePriceContextText: kdT('basePriceContext', 'From (cover only)'),
    totalWithOptionsText: kdT('totalWithOptions', 'Total with selected options'),
    priceNoteText: kdT('priceNote', 'Base price is the cover only. Total updates with selected options.')
  };

  const KD_UPGRADE = {
    handle: 'eye-design-upgrade',
    propKey: '_kd_upgrade',
    propVal: 'Eye Design Upgrade'
  };

  // ✅ Add-ons hidden product (HANDLE MUST MATCH PRODUCT URL HANDLE)
  const KD_ADDONS = {
    handle: 'screen-cover-add-on',
    propKey: '_kd_addon',
    propType: '_kd_type'
  };

  const KD_FASTTRACK = {
    variantId: 52232549597531,
    label: kdT('fastTrackLabel', 'Fast Track Production ({{ days }} days)', { days: kdInt(kdGetShopMeta('fast_track_days', 7), 7) }),
    propKey: '_kd_fast_track',
    propType: '_kd_type',
    typeVal: 'fast_track'
  };

  // ✅ Personalisation (per letter) — uses the Screen Cover Add-on variant
  const KD_PERSONALISE = {
    variantId: 52402354848091, // "Personalised Name (per letter)" variant inside Screen Cover Add-on
    pricePerLetterCents: 400,  // £4.00
    maxLetters: 20,
    propName: 'Personalised name',
    propFont: 'Font style',
    propLetters: 'Personalisation letters',
    propCost: 'Personalisation add-on',
    typeVal: 'personalisation'
  };

  const ADDON_NAMES = {
    BUS: 'Bus Mirrors',
    SUN: 'Sun Visor',
    SNORKEL_OS: 'Snorkel Adjustment when fitted to the OS',
    SNORKEL_NS: 'Snorkel Adjustment when fitted to the NS',
    DAY_USE: 'Day Use Drop Down',
    BLOODSHOT: 'Blood Shot Eyes'
  };

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const norm = (s) => (s || '').toString().trim().toLowerCase();

  function getRoot() {
    return document.querySelector('.kd-customiser') || document;
  }

  function isBlankDesign(val) {
    const v = norm(val);
    return !v || v === 'blank' || v.includes('blank');
  }

  /* =========================================================
     ✅ Personalisation helpers + UI binder
     ========================================================= */
  function kdCountChargeable(str) {
    // letters + digits only (spaces/punct free)
    return (String(str || '').match(/[A-Za-z0-9]/g) || []).length;
  }

  function kdClampPersonalisation(str) {
    let s = String(str || '');
    while (kdCountChargeable(s) > KD_PERSONALISE.maxLetters) s = s.slice(0, -1);
    return s;
  }

  function kdGetSelectedFontFromUI() {
    const ui = document.querySelector('[data-kd-personalise]');
    if (!ui) return 'Font A';
    const r = ui.querySelector('input[data-kd-font]:checked');
    return (r?.value || 'Font A').trim();
  }

  function kdGetPersonalisationSnapshot() {
    const data = window.kdPersonalisation || {};
    let name = (data.name || '').toString();
    let font = (data.font || '').toString() || 'Font A';

    // Fallback direct read from DOM
    const ui = document.querySelector('[data-kd-personalise]');
    if (ui) {
      const input = ui.querySelector('[data-kd-name]');
      if (input && !name) name = input.value || '';
      if (!data.font) font = kdGetSelectedFontFromUI();
    }

    name = kdClampPersonalisation(name);
    const letters = kdCountChargeable(name);
    const cents = letters * KD_PERSONALISE.pricePerLetterCents;

    return {
      name: name.trim(),
      font: (font || 'Font A').trim(),
      letters,
      cents
    };
  }

  function kdInitPersonalisationUI() {
    const ui = document.querySelector('[data-kd-personalise]');
    if (!ui || ui.dataset.kdBound === '1') return;
    ui.dataset.kdBound = '1';

    const input = ui.querySelector('[data-kd-name]');
    const preview = ui.querySelector('[data-kd-preview]');
    const countEl = ui.querySelector('[data-kd-count]');
    const priceEl = ui.querySelector('[data-kd-price]');
    const radios = Array.from(ui.querySelectorAll('input[data-kd-font]'));

    if (!input) return;

    function formatGBP(cents) {
      const cur = kdGetActiveCurrency();
      const n = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(n);
      } catch (e) {
        return `£${n.toFixed(2)}`;
      }
    }

    function render() {
      const raw = input.value || '';
      const clamped = kdClampPersonalisation(raw);
      if (clamped !== raw) input.value = clamped;

      const font = radios.find((r) => r.checked)?.value || 'Font A';
      const letters = kdCountChargeable(clamped);
      const cents = letters * KD_PERSONALISE.pricePerLetterCents;

      if (countEl) countEl.textContent = String(letters);
      if (priceEl) priceEl.textContent = formatGBP(cents);
      if (preview) preview.textContent = clamped || kdT('personalisationPreview', 'Preview');

      // NOTE: class toggles kept for backwards compatibility
      if (preview) {
        preview.classList.toggle('kd-font-a', font === 'Font A');
        preview.classList.toggle('kd-font-b', font === 'Font B');
      }

      window.kdPersonalisation = { name: clamped, font, letters, cents };
    }

    input.addEventListener('input', () => {
      render();
      kdSchedulePriceUpdate();
    });

    radios.forEach((r) =>
      r.addEventListener('change', () => {
        render();
        kdSchedulePriceUpdate();
      })
    );

    render();
  }

  /* =========================================================
     ✅ Inject CSS so snorkel tiles match add-ons tiles
     ========================================================= */
  function kdEnsureAddonTileCSS() {
    if (document.getElementById('kd-addon-tile-css')) return;

    const css = `
:root { --kd-accent:#ff7a00; }

/* Ensure both grids behave the same */
.kd-grid--addons,
.kd-grid--snorkel{
  gap: 12px;
}

/* Tile base for BOTH add-ons + snorkel tiles */
.kd-grid--addons label.kd-addon-tile,
.kd-grid--snorkel label.kd-addon-tile{
  position: relative;
  border: 1px solid rgba(0,0,0,.12);
  border-radius: 16px;
  background: #fff;
  padding: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow .15s ease, transform .08s ease, border-color .15s ease;
  display: grid;
  align-content: start;
  gap: 10px;
}

/* Hover */
.kd-grid--addons label.kd-addon-tile:hover,
.kd-grid--snorkel label.kd-addon-tile:hover{
  box-shadow: 0 8px 24px rgba(0,0,0,.10);
}

/* Images consistent */
.kd-grid--addons label.kd-addon-tile > img,
.kd-grid--snorkel label.kd-addon-tile > img{
  width: 100%;
  height: 92px;
  object-fit: cover;
  border-radius: 12px;
  background: #f2f2f2;
  border: 1px solid rgba(0,0,0,.08);
  display: block;
}

/* Title text */
.kd-grid--addons label.kd-addon-tile .kd-label,
.kd-grid--snorkel label.kd-addon-tile .kd-label{
  font-size: 16px;
  font-weight: 700;
  line-height: 1.15;
  margin: 0;
}

/* Price text (your injected .kd-addon-tile-price) */
.kd-grid--addons label.kd-addon-tile .kd-addon-tile-price,
.kd-grid--snorkel label.kd-addon-tile .kd-addon-tile-price{
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.2;
  opacity: .85;
  font-weight: 600;
}

/* Use aria-checked for selection (works for BOTH checkbox + radio) */
.kd-grid--addons label.kd-addon-tile[aria-checked="true"],
.kd-grid--snorkel label.kd-addon-tile[aria-checked="true"]{
  border-color: var(--kd-accent);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--kd-accent) 40%, transparent);
}

/* Badge circle + tick when selected */
.kd-grid--addons label.kd-addon-tile[aria-checked="true"]::before,
.kd-grid--snorkel label.kd-addon-tile[aria-checked="true"]::before{
  content: "";
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: var(--kd-accent);
  box-shadow: 0 2px 10px rgba(0,0,0,.18);
  z-index: 6;
  pointer-events: none;
}

.kd-grid--addons label.kd-addon-tile[aria-checked="true"]::after,
.kd-grid--snorkel label.kd-addon-tile[aria-checked="true"]::after{
  content: "✓";
  position: absolute;
  top: 16px;
  right: 20px;
  font-size: 16px;
  font-weight: 900;
  line-height: 1;
  color: #fff;
  z-index: 7;
  pointer-events: none;
}

/* Keep real inputs clickable but not visually in the way */
.kd-grid--addons label.kd-addon-tile input,
.kd-grid--snorkel label.kd-addon-tile input{
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

/* ✅ Pricing clarity helpers */
.kd-base-price-context{
  margin: 6px 0 0;
  font-size: 12px;
  opacity: .75;
}
.kd-price-note{
  margin-top: 2px;
  font-size: 12px;
  opacity: .75;
}
  /* ✅ De-emphasise the base price (left) */
.kd-base-price{
  opacity: .72;
  font-size: 0.92em;
}
.kd-base-price *{
  font-weight: 500;
}

/* ✅ Slightly emphasise total (right) */
.kd-live-price-wrap .kd-live-price{
  font-size: 1.15em;
}

    `.trim();

    const style = document.createElement('style');
    style.id = 'kd-addon-tile-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ---------------------------
     Find option block by visible label text (Prestige-safe)
     --------------------------- */
  function findOptionBlockByLabelText(labelText, scope = document) {
    scope = scope || document;
    const target = norm(labelText);
    if (!target) return null;

    const stableNameByLabel = {
      [norm(CFG.legends.cover)]: CFG.propCover,
      [norm(CFG.legends.eyeDesign)]: CFG.propEyeDesign,
      [norm(CFG.legends.eyeColour)]: CFG.propEyeColour
    };
    const stableName = stableNameByLabel[target];
    if (stableName) {
      const input = scope.querySelector(`input[name="${CSS.escape(stableName)}"]`);
      const block = input?.closest('fieldset, .kd-group, .product-form__input, .product-form__option, .variant-picker__option, .variant-picker');
      if (block) return block;
    }

    const CONTAINER_SELECTORS = [
      'fieldset',
      '.product-form__input',
      '.product-form__option',
      '.variant-picker__option',
      '.variant-picker',
      '.product-form',
      '.selector-wrapper',
      '.product__info',
      '.product__details'
    ].join(',');

    const LABEL_SELECTORS = [
      'legend',
      'label',
      '.product-form__label',
      '.product-form__option-name',
      '.variant-picker__label',
      '.option-selector__label',
      '.kd-label',
      'p',
      'span',
      'h3',
      'h4',
      'strong'
    ].join(',');

    const candidates = Array.from(scope.querySelectorAll(LABEL_SELECTORS));
    let best = null;
    let bestScore = -1;

    for (const el of candidates) {
      const txt = norm(el.textContent).replace(/:$/, '');
      if (!txt) continue;
      if (!txt.includes(target)) continue;

      const container = el.closest(CONTAINER_SELECTORS);
      if (!container) continue;

      const hasControls = container.querySelector('input, select, button');
      if (!hasControls) continue;

      let score = 0;
      if (txt === target) score += 6;
      if (txt.startsWith(target)) score += 3;
      if (el.tagName === 'LEGEND' || el.tagName === 'LABEL') score += 2;
      if (container.tagName === 'FIELDSET') score += 2;

      const childCount = container.querySelectorAll('*').length;
      score += Math.max(0, 6 - Math.min(6, Math.floor(childCount / 40)));

      if (score > bestScore) {
        bestScore = score;
        best = container;
      }
    }
    return best;
  }

  function getSelectedValueFromBlock(block) {
    if (!block) return '';
    const checked = block.querySelector('input[type="radio"]:checked');
    return (checked?.value || '').trim();
  }

  function clickValueInBlock(block, valueToSelect) {
    if (!block) return false;
    const target = norm(valueToSelect);

    const labels = Array.from(block.querySelectorAll('label'));
    for (const lbl of labels) {
      const input = lbl.control || lbl.querySelector('input[type="radio"]');
      if (!input) continue;
      const v = (input?.value || '').trim();
      const text = (lbl.textContent || '').trim();
      if (norm(v) === target || norm(text) === target || norm(text).includes(target)) {
        if (!input.disabled && !input.checked) lbl.click();
        return true;
      }
    }

    const inputs = Array.from(block.querySelectorAll('input[type="radio"]'));
    const found = inputs.find((i) => norm(i.value) === target);
    if (found && !found.disabled) {
      if (!found.checked) found.click();
      return true;
    }
    return false;
  }

  /* ---------------------------
     KD helper: filter/set/clear by input name
     --------------------------- */
  function kdSet(name, wantedText) {
    const wanted = norm(wantedText);
    const inputs = $$(`input[type="radio"][name="${name}"]`, getRoot());
    for (const i of inputs) {
      const v = norm(i.value);
      const lbl = i.closest('label');
      const lblText = lbl ? norm(lbl.textContent) : '';
      if (v === wanted || lblText.includes(wanted)) {
        if (!i.disabled && !i.checked) i.click();
        return true;
      }
    }
    return false;
  }

  function kdFilter(name, allowedTexts) {
    const allowed = allowedTexts.map(norm);
    const inputs = $$(`input[type="radio"][name="${name}"]`, getRoot());
    inputs.forEach((i) => {
      const lbl = i.closest('label');
      const v = norm(i.value);
      const lblText = lbl ? norm(lbl.textContent) : '';
      const ok = allowed.some((a) => v === a || lblText.includes(a));
      i.disabled = !ok;
      if (lbl) lbl.style.display = ok ? '' : 'none';
    });
  }

  function kdUnfilter(name) {
    const inputs = $$(`input[type="radio"][name="${name}"]`, getRoot());
    inputs.forEach((i) => {
      const lbl = i.closest('label');
      i.disabled = false;
      if (lbl) lbl.style.display = '';
    });
  }

  /* ---------------------------
     Eye colour hide/show when Blank
     ✅ scoped to .kd-customiser root (NOT the form)
     --------------------------- */
  function getEyeColourFieldset() {
    const root = getRoot();
    const any = root.querySelector(`input[name="${CFG.propEyeColour}"]`);
    return any ? any.closest('fieldset') : null;
  }

  function getEyeDesignValue() {
    const root = getRoot();
    const eye = root.querySelector(`input[name="${CFG.propEyeDesign}"]:checked`);
    return (eye?.value || '').trim();
  }

  function hideEyeColourIfBlank() {
    const root = getRoot();
    const eyeDesignVal = getEyeDesignValue();
    const blank = isBlankDesign(eyeDesignVal);

    const fs = getEyeColourFieldset();
    if (!fs) return;

    if (blank) {
      root.querySelectorAll(`input[type="radio"][name="${CFG.propEyeColour}"]`).forEach((i) => {
        if (i.checked) {
          i.checked = false;
          i.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      fs.style.display = 'none';
      fs.querySelectorAll(`input[name="${CFG.propEyeColour}"]`).forEach((el) => (el.disabled = true));
    } else {
      fs.style.display = '';
      fs.querySelectorAll(`input[name="${CFG.propEyeColour}"]`).forEach((el) => (el.disabled = false));
    }
  }

  /* ---------------------------
     ATC validation
     --------------------------- */
  function enforceATC() {
    const scopedFormId = getRoot().querySelector('input[form]')?.getAttribute('form');
    const form = (scopedFormId && document.getElementById(scopedFormId)) || $(CFG.formSelector);
    if (!form) return;

    const atc =
      form.querySelector('button[type="submit"][name="add"]') ||
      form.querySelector('button[type="submit"]');
    if (!atc) return;

    const coverPicked = !!getRoot().querySelector(`input[name="${CFG.propCover}"]:checked`);

    const eyesWrap = $(CFG.kdEyesWrapSelector);
    const eyesVisible = !!eyesWrap && eyesWrap.style.display !== 'none';

    const eyeDesignVal = getEyeDesignValue();
    const eyeDesignPicked = !!getRoot().querySelector(`input[name="${CFG.propEyeDesign}"]:checked`);
    const eyeIsBlank = isBlankDesign(eyeDesignVal);

    const eyeColourPicked = !!getRoot().querySelector(`input[name="${CFG.propEyeColour}"]:checked`);

    const ok = coverPicked && (!eyesVisible || (eyeDesignPicked && (eyeIsBlank || eyeColourPicked)));
    atc.disabled = !ok;
  }

  /* ---------------------------
     UI reorder: LED + Insulation ABOVE Cover colour
     --------------------------- */
  function reorderTopGroups(form) {
    if (form?.dataset?.kdReordered === '1') return;

    const coverBlock =
      findOptionBlockByLabelText(CFG.legends.cover, form) ||
      findOptionBlockByLabelText(CFG.legends.cover, document);

    const ledBlock =
      findOptionBlockByLabelText(CFG.legends.led, form) ||
      findOptionBlockByLabelText(CFG.legends.led, document);

    const insulationBlock =
      findOptionBlockByLabelText(CFG.legends.insulation, form) ||
      findOptionBlockByLabelText(CFG.legends.insulation, document);

    if (!coverBlock || !ledBlock) return;

    const shared =
      coverBlock.parentElement && coverBlock.parentElement.contains(ledBlock)
        ? coverBlock.parentElement
        : (coverBlock.closest(CFG.formSelector) || form || coverBlock.parentElement);

    if (!shared || !shared.contains(coverBlock) || !shared.contains(ledBlock)) return;

    if (insulationBlock && shared.contains(insulationBlock)) {
      shared.insertBefore(insulationBlock, coverBlock);
    }
    shared.insertBefore(ledBlock, coverBlock);

    if (form?.dataset) form.dataset.kdReordered = '1';
  }

  /* ---------------------------
     Main rule engine
     --------------------------- */
  function runRules() {
    const formEl = $(CFG.formSelector);
    const scope = formEl || document;

    reorderTopGroups(formEl);

    const ledGroup =
      findOptionBlockByLabelText(CFG.legends.led, scope) ||
      findOptionBlockByLabelText(CFG.legends.led, document);

    const insGroup =
      findOptionBlockByLabelText(CFG.legends.insulation, scope) ||
      findOptionBlockByLabelText(CFG.legends.insulation, document);

    const ledSelected = norm(getSelectedValueFromBlock(ledGroup));
    const isLedUpgrade = ledSelected === norm(CFG.values.ledUpgrade);

    if (isLedUpgrade) {
      clickValueInBlock(insGroup, CFG.values.thermal);

      kdFilter(CFG.propCover, [CFG.values.coverBlack]);
      kdSet(CFG.propCover, CFG.values.coverBlack);

      kdFilter(CFG.propEyeDesign, [CFG.values.eyeBlank]);
      kdSet(CFG.propEyeDesign, CFG.values.eyeBlank);

      const eyesWrap = $(CFG.kdEyesWrapSelector);
      if (eyesWrap) eyesWrap.style.display = 'none';

      hideEyeColourIfBlank();
    } else {
      kdUnfilter(CFG.propCover);
      kdUnfilter(CFG.propEyeDesign);

      const eyesWrap = $(CFG.kdEyesWrapSelector);
      if (eyesWrap) eyesWrap.style.display = '';

      hideEyeColourIfBlank();
    }

    enforceATC();
  }

  /* ---------------------------
     Tile data-name
     --------------------------- */
  function kdApplyTileNames(scope = document) {
    scope.querySelectorAll('.kd-customiser .kd-tile').forEach((tile) => {
      const img = tile.querySelector('img');
      if (img && img.alt) tile.setAttribute('data-name', img.alt.trim());
    });
  }

  /* ---------------------------
     Tile click fix (native click + immediate refresh)
     --------------------------- */
  function bindTileClickFix() {
    document.addEventListener(
      'click',
      (e) => {
        const tile = e.target.closest('.kd-customiser label.kd-tile');
        if (!tile) return;

        if (e.target && e.target.matches('input[type="radio"]')) return;

        const input = tile.querySelector('input[type="radio"]');
        if (!input || input.disabled) return;

        if (!input.checked) input.click();

        setTimeout(() => {
          hideEyeColourIfBlank();
          enforceATC();
          kdSchedulePriceUpdate();
        }, 0);
      },
      true
    );
  }

  /* =========================================================
     Metafield gating for add-ons
     Requires Liquid output: window.KD_PRODUCT_META = { supports_* }
     ========================================================= */

  function kdGetMetaBool(key, fallback = true) {
    const meta = window.KD_PRODUCT_META || {};
    const v = meta[key];
    if (typeof v === 'boolean') return v;
    if (typeof v === 'string') return ['true', '1', 'yes'].includes(norm(v));
    return fallback;
  }

  function kdSetAddonVisibility(addonName, visible) {
    const root = getRoot();
    const inputs = root.querySelectorAll(`input[data-kd-addon]`);
    inputs.forEach((i) => {
      const name = (i.value || '').trim();
      if (name !== addonName) return;

      const wrap = i.closest('label') || i.closest('.kd-addon') || i.parentElement;
      if (wrap) wrap.style.display = visible ? '' : 'none';

      i.disabled = !visible;
      if (!visible) {
        i.checked = false;
      }
    });
  }

  function kdApplyAddonGating() {
    // ✅ CRITICAL FIX:
    // If KD_PRODUCT_META is missing on this template/render, DO NOT hide anything.
    if (!window.KD_PRODUCT_META || typeof window.KD_PRODUCT_META !== 'object') {
      return;
    }

    const allowSun = kdGetMetaBool('supports_sun_visor', true);
    const allowBus = kdGetMetaBool('supports_bus_mirrors', true);
    const allowSnorkel = kdGetMetaBool('supports_snorkel', true);

    // off unless explicitly enabled (but only applies when meta exists)
    const allowBlood = kdGetMetaBool('supports_blood_shot_eyes', false);
    const allowDayUse = kdGetMetaBool('supports_day_use_dropdown', false);

    kdSetAddonVisibility(ADDON_NAMES.SUN, allowSun);
    kdSetAddonVisibility(ADDON_NAMES.BUS, allowBus);

    kdSetAddonVisibility(ADDON_NAMES.SNORKEL_OS, allowSnorkel);
    kdSetAddonVisibility(ADDON_NAMES.SNORKEL_NS, allowSnorkel);

    kdSetAddonVisibility(ADDON_NAMES.BLOODSHOT, allowBlood);
    kdSetAddonVisibility(ADDON_NAMES.DAY_USE, allowDayUse);
  }

  /* =========================================================
     Add-ons UI logic
     ========================================================= */

  function kdBindAddonRules() {
    document.addEventListener(
      'change',
      (e) => {
        const el = e.target;
        if (!el) return;

        if (
          el.matches(
            'input[type="checkbox"][data-kd-addon], input[type="radio"][data-kd-addon], input[name="kd_snorkel_side"]'
          )
        ) {
          const v = (el.value || '').trim();
          const isOS = v === ADDON_NAMES.SNORKEL_OS || norm(v).includes('to the os') || norm(v).includes('(os)');
          const isNS = v === ADDON_NAMES.SNORKEL_NS || norm(v).includes('to the ns') || norm(v).includes('(ns)');

          // Snorkel OS/NS exclusivity
          if (el.checked && (isOS || isNS)) {
            const other = isOS ? ADDON_NAMES.SNORKEL_NS : ADDON_NAMES.SNORKEL_OS;
            const root = getRoot();
            root
              .querySelectorAll(
                'input[type="checkbox"][data-kd-addon], input[type="radio"][data-kd-addon], input[name="kd_snorkel_side"]'
              )
              .forEach((i) => {
                const name = (i.value || '').trim();
                if (name === other) i.checked = false;
              });
          }
        }

        if (el.matches('input[data-kd-addon], input[data-kd-fasttrack], input[name="kd_snorkel_side"]')) {
          setTimeout(() => {
            kdHideNoSnorkel();
            kdSyncAddonTileStatesAndSizing();
            kdSchedulePriceUpdate();
          }, 0);
        }
      },
      true
    );
  }

  /* =========================================================
     ✅ aria-checked sync + normalize snorkel height
     ========================================================= */
  function kdNormalizeSnorkelTileHeight() {
    const root = getRoot();
    if (!root) return;

    // Base height from add-ons tiles
    const baseTile = root.querySelector('.kd-grid--addons label.kd-addon-tile:not([style*="display: none"])');
    const baseH = baseTile ? baseTile.getBoundingClientRect().height : 0;

    // Apply to snorkel tiles only (so they match)
    const snorkelTiles = root.querySelectorAll('.kd-grid--snorkel label.kd-addon-tile');
    snorkelTiles.forEach((lbl) => {
      if (baseH > 0) {
        lbl.style.minHeight = `${Math.round(baseH)}px`;
      } else {
        lbl.style.minHeight = '';
      }
    });
  }

  function kdSyncAddonTileStatesAndSizing() {
    const root = getRoot();
    if (!root) return;

    // ensure our styling is present for BOTH grids
    kdEnsureAddonTileCSS();

    // Sync aria-checked for all addon tiles
    const labels = root.querySelectorAll('label.kd-addon-tile');
    labels.forEach((lbl) => {
      const input = lbl.querySelector('input[type="checkbox"], input[type="radio"]');
      if (!input) return;

      lbl.setAttribute('aria-checked', input.checked ? 'true' : 'false');
      lbl.classList.toggle('is-checked', !!input.checked);
    });

    // For radio groups, enforce consistency
    const radios = root.querySelectorAll('label.kd-addon-tile input[type="radio"]');
    radios.forEach((r) => {
      if (!r.name) return;
      const group = root.querySelectorAll(`label.kd-addon-tile input[type="radio"][name="${CSS.escape(r.name)}"]`);
      const checked = Array.from(group).find((x) => x.checked);
      if (!checked) return;

      group.forEach((x) => {
        const lbl = x.closest('label.kd-addon-tile');
        if (!lbl) return;
        lbl.setAttribute('aria-checked', x.checked ? 'true' : 'false');
        lbl.classList.toggle('is-checked', !!x.checked);
      });
    });

    kdNormalizeSnorkelTileHeight();
  }

  /* =========================================================
     ✅ Hide "No snorkel" tile (if it exists)
     ========================================================= */
  function kdHideNoSnorkel() {
    const root = getRoot();

    const inputs = root.querySelectorAll('input[name="kd_snorkel_side"], input[data-kd-addon]');
    inputs.forEach((i) => {
      const wrap = i.closest('label') || i.closest('.kd-addon') || i.parentElement;
      if (!wrap) return;

      const v = norm(i.value);
      const t = norm(wrap.textContent);
      const snorkelSide = norm(i.getAttribute('data-kd-addon-snorkel') || '');

      const isNo =
        snorkelSide === 'none' ||
        v === 'no snorkel' ||
        v === 'none' ||
        v === 'no' ||
        v === '0' ||
        t.includes('no snorkel');

      if (!isNo) return;

      wrap.style.display = 'none';
      i.disabled = true;
      i.checked = false;
    });
  }

  /* =========================================================
     Eye Design Upgrade – Prestige-safe intercept
     ========================================================= */

  let kdUpgradeProductCache = null;

  function kdFixDesignName(name) {
    const n = norm(name);
    const map = { soophie: 'sophie' };
    return map[n] || n;
  }

  async function kdFetchOptionProduct(handle, signal) {
    const controller = new AbortController();
    const onAbort = () => controller.abort(signal?.reason);
    if (signal?.aborted) onAbort();
    else signal?.addEventListener('abort', onAbort, { once: true });
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(`${root}products/${handle}.js`, {
        credentials: 'same-origin', signal: controller.signal
      });
      if (!res.ok) throw new Error(`option product fetch ${res.status}`);
      return await res.json();
    } finally {
      clearTimeout(timeout);
      signal?.removeEventListener('abort', onAbort);
    }
  }

  async function kdFetchUpgradeProduct(signal) {
    if (kdUpgradeProductCache) return kdUpgradeProductCache;
    kdUpgradeProductCache = await kdFetchOptionProduct(KD_UPGRADE.handle, signal);
    return kdUpgradeProductCache;
  }

  async function kdGetUpgradeVariantForDesign(designName, signal) {
    const wanted = kdFixDesignName(designName);
    if (!wanted) return null;

    const product = await kdFetchUpgradeProduct(signal);
    const variants = product.variants || [];

    let v = variants.find((vv) => norm(vv.option1) === wanted);
    if (!v) v = variants.find((vv) => norm(vv.title) === wanted);
    if (!v) v = variants.find((vv) => norm(vv.title).includes(wanted));

    if (!v) {
      console.warn('[KD] No matching upgrade variant for design:', designName, 'Wanted:', wanted);
      return null;
    }
    return v;
  }

  async function kdGetUpgradeVariantIdForDesign(designName) {
    const v = await kdGetUpgradeVariantForDesign(designName);
    return v ? v.id : null;
  }

  /* =========================================================
     Add-ons hidden product fetch + match + IMAGES + TILE PRICES
     ========================================================= */

  let kdAddonsProductCache = null;
  let kdAddonImageMap = null; // name(lower) -> image src
  let kdAddonPriceMap = null; // name(lower) -> price cents

  async function kdFetchAddonsProduct(signal) {
    if (kdAddonsProductCache) return kdAddonsProductCache;
    kdAddonsProductCache = await kdFetchOptionProduct(KD_ADDONS.handle, signal);
    return kdAddonsProductCache;
  }

  async function kdGetAddonVariantByName(name, signal) {
    const product = await kdFetchAddonsProduct(signal);
    const wanted = norm(name);
    const variants = product.variants || [];

    let v = variants.find((vv) => norm(vv.option1) === wanted);
    if (!v) v = variants.find((vv) => norm(vv.title) === wanted);
    if (!v) v = variants.find((vv) => norm(vv.title).includes(wanted));
    return v || null;
  }

  function kdBestVariantImageSrc(variant) {
    if (!variant) return '';

    if (variant.featured_image && typeof variant.featured_image === 'object' && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (variant.featured_image && typeof variant.featured_image === 'string') {
      return variant.featured_image;
    }
    if (variant.image && typeof variant.image === 'object' && variant.image.src) {
      return variant.image.src;
    }

    if (variant.featured_media?.preview_image?.src) return variant.featured_media.preview_image.src;
    if (variant.featured_media?.src) return variant.featured_media.src;

    return '';
  }

  async function kdBuildAddonMaps() {
    if (kdAddonImageMap && kdAddonPriceMap) return { img: kdAddonImageMap, price: kdAddonPriceMap };

    const product = await kdFetchAddonsProduct();
    const variants = product.variants || [];

    const imgMap = {};
    const priceMap = {};

    variants.forEach((v) => {
      const keys = [(v.option1 || '').trim(), (v.title || '').trim()].filter(Boolean);

      const src = kdBestVariantImageSrc(v);
      const price = Number(v.price || 0);

      keys.forEach((k) => {
        const nk = norm(k);
        if (!nk) return;
        if (src) imgMap[nk] = src;
        priceMap[nk] = price;
      });
    });

    kdAddonImageMap = imgMap;
    kdAddonPriceMap = priceMap;
    return { img: imgMap, price: priceMap };
  }

  async function kdApplyAddonImages() {
    const root = getRoot();
    if (!root || !root.querySelector('[data-kd-addons]')) return;

    let maps = null;
    try {
      maps = await kdBuildAddonMaps();
    } catch (e) {
      console.warn('[KD] Could not build add-on maps:', e);
      return;
    }

    const imgMap = maps.img;

    const addonInputs = root.querySelectorAll('input[data-kd-addon]');
    addonInputs.forEach((input) => {
      const name = (input.value || '').trim();
      if (!name) return;

      const img = input.closest('label')?.querySelector('img[data-kd-addon-img], img.kd-addon-img, img.kd-addon-img');
      if (!img) return;

      const src = imgMap[norm(name)];
      if (!src) {
        img.style.display = 'none';
        img.removeAttribute('src');
        return;
      }

      img.setAttribute('src', src);
      img.setAttribute('alt', name);
      img.style.display = '';
    });

    kdApplyTileNames(root);
  }

  function kdFindAddonTileLabel(input) {
    return input.closest('label') || input.closest('.kd-addon') || input.parentElement;
  }

  function kdGetActiveCurrency() {
    return window.Shopify?.currency?.active || 'GBP';
  }

  function kdFormatMoney(cents) {
    const n = Number(cents || 0) / 100;
    const cur = kdGetActiveCurrency();
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(n);
    } catch (e) {
      return `£${n.toFixed(2)}`;
    }
  }

  async function kdApplyAddonTilePrices() {
    const root = getRoot();
    if (!root || !root.querySelector('[data-kd-addons]')) return;

    let maps = null;
    try {
      maps = await kdBuildAddonMaps();
    } catch (e) {
      console.warn('[KD] Could not build add-on price map:', e);
      return;
    }

    const priceMap = maps.price;
    const addonInputs = root.querySelectorAll('input[data-kd-addon]');

    addonInputs.forEach((input) => {
      const name = (input.value || '').trim();
      if (!name) return;

      const wrap = kdFindAddonTileLabel(input);
      if (!wrap) return;
      if (wrap.style.display === 'none') return;

      const cents = Number(priceMap[norm(name)] ?? 0);

      let priceEl = wrap.querySelector('.kd-addon-tile-price');
      if (!priceEl) {
        priceEl = document.createElement('div');
        priceEl.className = 'kd-addon-tile-price';

        const titleGuess =
          wrap.querySelector('.kd-tile__title, .kd-tile-title, .kd-label, .kd-name, .tile__title, .tile-title') ||
          wrap.querySelector('span.kd-label, span, p, strong');
        if (titleGuess && titleGuess.parentElement) {
          titleGuess.parentElement.insertAdjacentElement('beforeend', priceEl);
        } else {
          wrap.appendChild(priceEl);
        }
      }

      const priceText = cents > 0 ? `+${kdFormatMoney(cents)}` : kdT('included', 'Included');
      if (priceEl.textContent !== priceText) priceEl.textContent = priceText;
    });
  }

  function kdGetSelectedAddons() {
    const root = getRoot();

    const checkedCbs = root.querySelectorAll('input[type="checkbox"][data-kd-addon]:checked');
    const cbNames = Array.from(checkedCbs).map((i) => (i.value || '').trim()).filter(Boolean);

    const checkedRadios = root.querySelectorAll('input[type="radio"][data-kd-addon]:checked');
    const radioNames = Array.from(checkedRadios).map((i) => (i.value || '').trim()).filter(Boolean);

    return Array.from(new Set([...cbNames, ...radioNames]));
  }

  function kdGetCurrentEyeDesignValue() {
    return getEyeDesignValue();
  }

  function kdIsFastTrackSelected() {
    const el = document.querySelector('input[data-kd-fasttrack]');
    return !!(el && el.checked);
  }

  /* =========================================================
     ✅ LEAD TIME snapshot saved into order properties
     Requires Liquid: window.KD_SHOP_META = { lead_time_days, lead_time_display_text, fast_track_days }
     ========================================================= */

  function kdGetShopMeta(key, fallback = null) {
    const meta = window.KD_SHOP_META || {};
    const v = meta[key];
    return (v === undefined || v === null || v === '') ? fallback : v;
  }

  function kdInt(val, fallback = 0) {
    const n = parseInt(val, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function kdFormatDateUK(dateObj) {
    try {
      return new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).format(dateObj);
    } catch (e) {
      const d = dateObj;
      return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
    }
  }

  function kdComputeLeadTimeSnapshot(isFastTrack) {
    const baseDays = kdInt(kdGetShopMeta('lead_time_days', 0), 0);
    const baseText = String(kdGetShopMeta('lead_time_display_text', '') || '').trim();
    const ftDays = kdInt(kdGetShopMeta('fast_track_days', 7), 7);

    const days = isFastTrack ? ftDays : baseDays;
    const label = isFastTrack
      ? (days ? kdT('leadTimeFastTrack', '{{ days }} days (Fast Track)', { days }) : KD_FASTTRACK.label)
      : (baseText || (days ? kdT('leadTimeDays', '{{ days }} days', { days }) : ''));

    const shipDate = days ? new Date(Date.now() + (days * 24 * 60 * 60 * 1000)) : null;

    return {
      days,
      label,
      shipDateText: shipDate ? kdFormatDateUK(shipDate) : ''
    };
  }

  function buildMultiAddFormData({
    mainId,
    qty,
    mainProps,
    addUpgrade,
    upgradeId,
    eyeDesign,
    passthroughFD,
    addonItems,
    fastTrackItem
  }) {
    const fd = new FormData();

    if (passthroughFD) {
      ['sections', 'sections_url'].forEach((k) => {
        const v = passthroughFD.get(k);
        if (v != null) fd.set(k, v);
      });
    }

    fd.set('items[0][id]', String(mainId));
    fd.set('items[0][quantity]', String(qty));
    Object.entries(mainProps || {}).forEach(([k, v]) => {
      fd.set(`items[0][properties][${k}]`, String(v));
    });

    let idx = 1;

    if (addUpgrade && upgradeId) {
      fd.set(`items[${idx}][id]`, String(upgradeId));
      fd.set(`items[${idx}][quantity]`, String(qty));
      fd.set(`items[${idx}][properties][${KD_UPGRADE.propKey}]`, KD_UPGRADE.propVal);
      fd.set(`items[${idx}][properties][Eye design upgrade for]`, String(eyeDesign || ''));
      fd.set(`items[${idx}][properties][_kd_type]`, 'eye_design_upgrade');
      idx++;
    }

    // ✅ Add-ons can have their own quantity + extra properties (used by Personalisation per-letter)
    (addonItems || []).forEach((a) => {
      if (!a || !a.id) return;

      const itemQty = Number(a.quantity || qty || 1);

      fd.set(`items[${idx}][id]`, String(a.id));
      fd.set(`items[${idx}][quantity]`, String(itemQty));

      fd.set(`items[${idx}][properties][${KD_ADDONS.propKey}]`, String(a.name || 'Add-on'));
      fd.set(`items[${idx}][properties][${KD_ADDONS.propType}]`, String(a.type || 'addon'));

      if (a.properties && typeof a.properties === 'object') {
        Object.entries(a.properties).forEach(([k, v]) => {
          fd.set(`items[${idx}][properties][${k}]`, String(v));
        });
      }

      idx++;
    });

    if (fastTrackItem && fastTrackItem.id) {
      fd.set(`items[${idx}][id]`, String(fastTrackItem.id));
      fd.set(`items[${idx}][quantity]`, String(qty));
      fd.set(`items[${idx}][properties][${KD_FASTTRACK.propKey}]`, KD_FASTTRACK.label);
      fd.set(`items[${idx}][properties][${KD_FASTTRACK.propType}]`, KD_FASTTRACK.typeVal);
      idx++;
    }

    return fd;
  }

  function kdCartSelectionError(message) {
    const error = new Error(message);
    error.kdCartMessage = true;
    return error;
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = async function (input, init = {}) {
    try {
      const url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      const isAdd = url.includes('/cart/add.js');

      if (!isAdd) return originalFetch(input, init);
      if (!document.querySelector('.kd-customiser')) return originalFetch(input, init);

      const body = init.body;
      if (!(body instanceof FormData)) return originalFetch(input, init);

      const mainId = parseInt(body.get('id'), 10);
      const qty = parseInt(body.get('quantity') || '1', 10) || 1;
      if (!mainId) return originalFetch(input, init);

      const mainProps = {};
      for (const [k, v] of body.entries()) {
        const m = String(k).match(/^properties\[(.+)\]$/);
        if (m) mainProps[m[1]] = v;
      }

      // Ensure personalisation UI state is up to date right before ATC
      kdInitPersonalisationUI();

      const fastTrackSelected = kdIsFastTrackSelected();
      const selectedAddons = kdGetSelectedAddons();
      const personalisation = kdGetPersonalisationSnapshot();

      const eyeDesignRaw = kdGetCurrentEyeDesignValue();
      const eyeDesign = eyeDesignRaw;
      const blank = isBlankDesign(eyeDesignRaw);

      if (eyeDesign) mainProps['Eye design'] = eyeDesign;

      let upgradeId = null;
      if (!blank) {
        const upgradeVariant = await kdGetUpgradeVariantForDesign(eyeDesignRaw, init.signal).catch(() => null);
        if (!upgradeVariant?.id || upgradeVariant.available !== true) {
          throw kdCartSelectionError(kdT('eyeDesignUnavailable', 'This eye design could not be confirmed as available. Please choose another design or try again.'));
        }
        upgradeId = upgradeVariant.id;
      }

      const addonItems = [];

      for (const name of selectedAddons) {
        const v = await kdGetAddonVariantByName(name, init.signal).catch(() => null);
        if (!v?.id || v.available !== true) {
          throw kdCartSelectionError(kdT('addonUnavailable', '{{ addon }} could not be confirmed as available. Please deselect it or try again.', { addon: name }));
        }
        addonItems.push({ id: v.id, name, type: 'addon' });
      }

      // ✅ Personalisation (per letter) add-on
      const p = personalisation;
      if (p && p.letters > 0 && p.name) {
        // Save onto MAIN line item properties (best for production)
        mainProps[KD_PERSONALISE.propName] = p.name;
        mainProps[KD_PERSONALISE.propFont] = p.font;
        mainProps[KD_PERSONALISE.propLetters] = String(p.letters);
        mainProps[KD_PERSONALISE.propCost] = kdFormatMoney(p.cents);

        // Add per-letter add-on variant with quantity = letters
        addonItems.push({
          id: KD_PERSONALISE.variantId,
          name: 'Personalised Name (per letter)',
          quantity: p.letters,
          type: KD_PERSONALISE.typeVal,
          properties: {
            [KD_PERSONALISE.propName]: p.name,
            [KD_PERSONALISE.propFont]: p.font
          }
        });
      }

      let fastTrackItem = null;
      if (fastTrackSelected) {
        const fv = await kdGetFastTrackVariant(true);
        if (fv?.available === true) {
          fastTrackItem = { id: KD_FASTTRACK.variantId };
        } else {
          await kdUpdateFastTrackUI();
          throw kdCartSelectionError(kdT('fastTrackUnavailable', 'Fast Track is currently unavailable. It has been deselected; please review your order and add to cart again.'));
        }
      }

      const leadSnap = kdComputeLeadTimeSnapshot(Boolean(fastTrackItem));
      if (leadSnap.label) mainProps['Lead time at order'] = leadSnap.label;
      if (leadSnap.shipDateText) mainProps['Expected ship date'] = leadSnap.shipDateText;
      if (leadSnap.days) mainProps['_kd_lead_time_days'] = String(leadSnap.days);

      const multiFD = buildMultiAddFormData({
        mainId,
        qty,
        mainProps,
        addUpgrade: !blank && !!upgradeId,
        upgradeId,
        eyeDesign,
        passthroughFD: body,
        addonItems,
        fastTrackItem
      });

      const headers = new Headers(init.headers);
      headers.set('Accept', 'application/json');
      return await originalFetch(input, {
        ...init,
        method: 'POST',
        credentials: 'same-origin',
        headers,
        body: multiFD
      });
    } catch (err) {
      console.warn('[KD] fetch intercept error:', err);
      throw err;
    }
  };

  /* =========================================================
     ✅ LIVE PRICE + BREAKDOWN
     ========================================================= */

  let kdMainProductCache = null;
  let kdMainProductHandleCache = null;

  function kdGetCurrentVariantId() {
    const form = $(CFG.formSelector);
    const idInput = form?.querySelector('input[name="id"]') || document.querySelector('input[name="id"]');
    const id = parseInt(idInput?.value || '', 10);
    return Number.isFinite(id) ? id : null;
  }

  function kdGetProductHandleFromPage() {
    if (kdMainProductHandleCache) return kdMainProductHandleCache;

    const path = (location.pathname || '').split('?')[0];
    const m = path.match(/\/products\/([^\/]+)/);
    if (m && m[1]) {
      kdMainProductHandleCache = m[1];
      return kdMainProductHandleCache;
    }

    const og = document.querySelector('meta[property="og:url"]')?.getAttribute('content') || '';
    const mm = og.match(/\/products\/([^\/\?\#]+)/);
    if (mm && mm[1]) {
      kdMainProductHandleCache = mm[1];
      return kdMainProductHandleCache;
    }

    return null;
  }

  async function kdFetchMainProduct() {
    if (kdMainProductCache) return kdMainProductCache;

    const handle = kdGetProductHandleFromPage();
    if (!handle) throw new Error('[KD] Could not determine current product handle for live price.');

    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`[KD] Failed to fetch main product JSON: ${res.status}`);

    kdMainProductCache = await res.json();
    return kdMainProductCache;
  }

  async function kdGetBaseVariantPriceCents() {
    const variantId = kdGetCurrentVariantId();
    if (!variantId) return null;

    const product = await kdFetchMainProduct();
    const v = (product.variants || []).find((x) => Number(x.id) === Number(variantId));
    if (!v) return null;

    return Number(v.price || 0);
  }

  function kdFindPriceAnchor() {
    const productInfo = document.querySelector('safe-sticky.product-info, .product-info');
    if (productInfo) {
      const pl = productInfo.querySelector('price-list.price-list');
      if (pl) return pl;

      const inner = productInfo.querySelector('.price-list');
      if (inner) return inner;
    }

    return (
      document.querySelector('price-list.price-list') ||
      document.querySelector('.product__info .price-list') ||
      document.querySelector('.price-list') ||
      document.querySelector('.product__info .product-info__price') ||
      document.querySelector('.product__price') ||
      document.querySelector('[data-price-list]') ||
      document.querySelector('[data-product-price]') ||
      document.querySelector('.product-info') ||
      null
    );
  }

  /* =========================================================
     ✅ Pricing clarity: base price context label (NEW)
     ========================================================= */
  function kdEnsureBasePriceContextUI() {
  const anchor = kdFindPriceAnchor();
  if (!anchor) return;

  // ✅ apply styling class to the base price element (de-emphasis)
  anchor.classList.add('kd-base-price');

  // Try to insert right above the base price list area
  const host = anchor.parentElement || anchor;
  if (!host) return;

  // Already added?
  if (host.querySelector('.kd-base-price-context')) return;

  const p = document.createElement('div');
  p.className = 'kd-base-price-context';
  p.textContent = CFG.basePriceContextText;

  // Insert before the price list element to sit directly above the base price
  anchor.insertAdjacentElement('beforebegin', p);
}

  /* =========================================================
     FAST TRACK variant fetch + UI
     ========================================================= */

  let kdFastTrackVariantCache = null;
  let kdFastTrackVariantCacheTime = 0;
  let kdFastTrackVariantRequest = null;

  async function kdGetFastTrackVariant(forceRefresh = false) {
    const now = Date.now();
    if (!forceRefresh && (now - kdFastTrackVariantCacheTime) < 30000) return kdFastTrackVariantCache;
    if (kdFastTrackVariantRequest) return kdFastTrackVariantRequest;

    kdFastTrackVariantRequest = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const res = await fetch(`${root}variants/${KD_FASTTRACK.variantId}.js`, {
          credentials: 'same-origin', signal: controller.signal
        });
        if (!res.ok) throw new Error(`variant fetch ${res.status}`);
        const data = await res.json();
        kdFastTrackVariantCache = Number(data?.id) === KD_FASTTRACK.variantId && typeof data.available === 'boolean' ? data : null;
        kdFastTrackVariantCacheTime = Date.now();
        return kdFastTrackVariantCache;
      } catch (e) {
        console.warn('[KD] Fast Track variant fetch failed:', e);
        kdFastTrackVariantCache = null;
        kdFastTrackVariantCacheTime = Date.now();
        return null;
      } finally {
        clearTimeout(timeout);
      }
    })();
    try {
      return await kdFastTrackVariantRequest;
    } finally {
      kdFastTrackVariantRequest = null;
    }
  }

  async function kdUpdateFastTrackUI() {
    const wraps = document.querySelectorAll('.kd-fasttrack-wrap');
    if (!wraps.length) return;
    const v = await kdGetFastTrackVariant();
    const available = v?.available === true;
    const cents = Number(v?.price || 0);
    const inv = typeof v?.inventory_quantity === 'number' ? v.inventory_quantity : null;
    const priceText = available ? `+${kdFormatMoney(cents)}` : '';
    const slotsText = !available ? '' : inv != null
      ? kdT(inv === 1 ? 'fastTrackSlotOne' : 'fastTrackSlotOther', inv === 1 ? '{{ count }} fast track slot remaining' : '{{ count }} fast track slots remaining', { count: inv })
      : kdT('fastTrackLimitedSlots', 'Limited weekly slots');

    wraps.forEach((wrap) => {
      const cb = wrap.querySelector('input[data-kd-fasttrack]');
      const priceEl = wrap.querySelector('.kd-fasttrack-price');
      const slotsEl = wrap.querySelector('.kd-fasttrack-slots');
      wrap.hidden = !available;
      wrap.style.display = available ? 'grid' : 'none';
      if (cb) {
        cb.disabled = !available;
        if (!available) cb.checked = false;
      }
      if (priceEl && priceEl.textContent !== priceText) priceEl.textContent = priceText;
      if (slotsEl && slotsEl.textContent !== slotsText) slotsEl.textContent = slotsText;
    });
  }

  function kdEnsureLivePriceUI() {
    if (document.querySelector('.kd-live-price-wrap')) return;

    const anchor = kdFindPriceAnchor();
    if (!anchor) return;

    const wrap = document.createElement('div');
    wrap.className = 'kd-live-price-wrap';
    wrap.style.marginTop = '10px';
    wrap.style.padding = '10px 12px';
    wrap.style.border = '1px solid rgba(0,0,0,0.10)';
    wrap.style.borderRadius = '12px';
    wrap.style.display = 'grid';
    wrap.style.gap = '6px';

    const top = document.createElement('div');
    top.style.display = 'flex';
    top.style.justifyContent = 'space-between';
    top.style.alignItems = 'baseline';
    top.style.gap = '10px';

    const left = document.createElement('span');
    left.className = 'kd-live-price-label';
    // ✅ changed wording
    left.textContent = CFG.totalWithOptionsText;

    const right = document.createElement('strong');
    right.className = 'kd-live-price';
    right.textContent = '';

    top.appendChild(left);
    top.appendChild(right);

    // ✅ small transparency note (reduces “trick” perception)
    const note = document.createElement('div');
    note.className = 'kd-price-note';
    note.textContent = CFG.priceNoteText;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'kd-price-breakdown-toggle';
    toggle.textContent = kdT('viewBreakdown', 'View breakdown');
    toggle.style.background = 'transparent';
    toggle.style.border = '0';
    toggle.style.padding = '0';
    toggle.style.textAlign = 'left';
    toggle.style.fontSize = '12px';
    toggle.style.cursor = 'pointer';
    toggle.style.opacity = '0.85';
    toggle.style.width = 'fit-content';

    const breakdown = document.createElement('div');
    breakdown.className = 'kd-price-breakdown';
    breakdown.style.display = 'none';
    breakdown.style.borderTop = '1px solid rgba(0,0,0,0.08)';
    breakdown.style.paddingTop = '8px';
    breakdown.style.fontSize = '12px';
    breakdown.style.lineHeight = '1.4';
    breakdown.style.opacity = '0.9';

    toggle.addEventListener('click', () => {
      const open = breakdown.style.display !== 'none';
      breakdown.style.display = open ? 'none' : 'block';
      toggle.textContent = open ? kdT('viewBreakdown', 'View breakdown') : kdT('hideBreakdown', 'Hide breakdown');
    });

    wrap.appendChild(top);
    wrap.appendChild(note);
    wrap.appendChild(toggle);
    wrap.appendChild(breakdown);

    anchor.insertAdjacentElement('afterend', wrap);
  }

  async function kdComputeBreakdown() {
    const base = await kdGetBaseVariantPriceCents();
    if (base == null) return null;

    const lines = [];
    let addonsTotal = 0;

    const eyeDesign = kdGetCurrentEyeDesignValue();
    const blank = isBlankDesign(eyeDesign);
    if (!blank) {
      try {
        const v = await kdGetUpgradeVariantForDesign(eyeDesign);
        if (v) {
          const cents = Number(v.price || 0);
          addonsTotal += cents;
          lines.push({
            label: kdT('eyeDesignUpgrade', 'Eye design upgrade ({{ design }})', { design: eyeDesign }),
            cents
          });
        }
      } catch (e) {
        console.warn('[KD] breakdown: upgrade price fetch failed:', e);
      }
    }

    const selected = kdGetSelectedAddons();
    if (selected.length) {
      try {
        const maps = await kdBuildAddonMaps();
        const priceMap = maps.price;

        selected.forEach((name) => {
          const cents = Number(priceMap[norm(name)] ?? 0);
          addonsTotal += cents;
          lines.push({ label: name, cents });
        });
      } catch (e) {
        console.warn('[KD] breakdown: add-on price fetch failed:', e);
      }
    }

    if (kdIsFastTrackSelected()) {
      try {
        const v = await kdGetFastTrackVariant();
        if (v && v.available !== false) {
          const cents = Number(v.price || 0);
          addonsTotal += cents;
          lines.push({ label: KD_FASTTRACK.label, cents });
        }
      } catch (e) {
        console.warn('[KD] breakdown: fast track fetch failed:', e);
      }
    }

    // ✅ Personalisation line (£4 per letter)
    const p = kdGetPersonalisationSnapshot();
    if (p && p.letters > 0 && p.name) {
      addonsTotal += Number(p.cents || 0);
      lines.push({ label: kdT('personalisedNameLetters', 'Personalised name ({{ count }} letters)', { count: p.letters }), cents: Number(p.cents || 0) });
    }

    const total = Number(base) + Number(addonsTotal);
    return { base, addonsTotal, total, lines };
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function kdRenderBreakdown(bd) {
    const out = document.querySelector('.kd-live-price');
    const box = document.querySelector('.kd-price-breakdown');
    if (!out || !box) return;

    const totalText = kdFormatMoney(bd.total);
    if (out.textContent !== totalText) out.textContent = totalText;

    const rows = [];
    // ✅ clarified wording
    rows.push(`<div style="display:flex;justify-content:space-between;gap:10px;">
      <span>${escapeHtml(kdT('baseCover', 'Base cover (cover only)'))}</span><strong>${kdFormatMoney(bd.base)}</strong>
    </div>`);

    bd.lines.forEach((l) => {
      rows.push(`<div style="display:flex;justify-content:space-between;gap:10px;">
        <span>${escapeHtml(l.label)}</span><strong>+${kdFormatMoney(l.cents)}</strong>
      </div>`);
    });

    rows.push(`<div style="margin-top:6px;display:flex;justify-content:space-between;gap:10px;
      padding-top:6px;border-top:1px solid rgba(0,0,0,0.08);">
      <span><strong>${escapeHtml(kdT('total', 'Total'))}</strong></span><strong>${kdFormatMoney(bd.total)}</strong>
    </div>`);

    const markup = rows.join('');
    if (box.dataset.kdRenderedMarkup !== markup) {
      box.innerHTML = markup;
      box.dataset.kdRenderedMarkup = markup;
    }
  }

  let kdPriceRaf = 0;
  function kdSchedulePriceUpdate() {
    if (kdPriceRaf) cancelAnimationFrame(kdPriceRaf);
    kdPriceRaf = requestAnimationFrame(() => {
      kdUpdateLivePrice().catch((e) => console.warn('[KD] live price update error:', e));
    });
  }

  async function kdUpdateLivePrice() {
    if (!document.querySelector('.kd-customiser')) return;

    // ✅ ensure base price has context label
    kdEnsureBasePriceContextUI();

    await kdUpdateFastTrackUI();

    kdEnsureLivePriceUI();

    const bd = await kdComputeBreakdown();
    const wrap = document.querySelector('.kd-live-price-wrap');
    if (!wrap) return;

    if (!bd) {
      wrap.style.display = 'none';
      return;
    }
    wrap.style.display = '';

    kdRenderBreakdown(bd);
  }

  /* ---------------------------
     Debounced rerender hook
     --------------------------- */
  let kdRaf = 0;
  function scheduleRun() {
    if (kdRaf) cancelAnimationFrame(kdRaf);
    kdRaf = requestAnimationFrame(() => {
      const form = $(CFG.formSelector);
      if (form?.dataset) form.dataset.kdReordered = '0';

      kdEnsureAddonTileCSS();

      kdApplyTileNames();
      kdApplyAddonGating();

      kdApplyAddonImages();
      kdApplyAddonTilePrices();

      kdHideNoSnorkel();
      kdSyncAddonTileStatesAndSizing();

      kdInitPersonalisationUI(); // ✅ rebind after rerenders

      // ✅ ensure base price label persists after rerender
      kdEnsureBasePriceContextUI();

      runRules();
      kdSchedulePriceUpdate();
    });
  }

  function bind() {
    kdEnsureAddonTileCSS();

    kdApplyTileNames();
    bindTileClickFix();
    kdBindAddonRules();

    kdApplyAddonGating();
    kdApplyAddonImages();
    kdApplyAddonTilePrices();

    kdHideNoSnorkel();
    kdSyncAddonTileStatesAndSizing();

    kdInitPersonalisationUI(); // ✅ bind once on load

    // ✅ add base price context label on load
    kdEnsureBasePriceContextUI();

    runRules();
    kdSchedulePriceUpdate();

    document.addEventListener(
      'click',
      (e) => {
        if (e.target.closest('variant-picker, .variant-picker, .kd-customiser')) {
          setTimeout(scheduleRun, 0);
        }
      },
      true
    );

    document.addEventListener(
      'change',
      (e) => {
        if (e.target.closest('variant-picker, .variant-picker, .kd-customiser')) {
          setTimeout(scheduleRun, 0);
        }
      },
      true
    );

    document.addEventListener('product:rerender', () => setTimeout(scheduleRun, 0), true);

    document.addEventListener('shopify:section:load', (e) => {
      kdApplyTileNames(e.target);
      setTimeout(() => {
        kdEnsureBasePriceContextUI();
        kdSchedulePriceUpdate();
      }, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

/* =========================================================
   Font preview helper (kept as-is)
   ========================================================= */
(function () {
  function setPreviewFont(root) {
    const preview = root.querySelector("[data-kd-preview]");
    if (!preview) return;

    const selected = root.querySelector('input[data-kd-font]:checked');
    if (!selected) return;

    // We stored the full font-family string in the radio value
    preview.style.fontFamily = selected.value;
  }

  // When a font is changed
  document.addEventListener("change", function (e) {
    if (!e.target.matches("[data-kd-font]")) return;

    const root = e.target.closest("[data-kd-personalise]");
    if (!root) return;

    setPreviewFont(root);
  });

  // When the name is typed, your existing code updates preview text.
  // We also re-apply the selected font afterwards (covers overwrites).
  document.addEventListener("input", function (e) {
    if (!e.target.matches("[data-kd-name]")) return;

    const root = e.target.closest("[data-kd-personalise]");
    if (!root) return;

    // let your existing code run first, then set font
    setTimeout(() => setPreviewFont(root), 0);
  });

  // Set default on load (covers theme editor / rerenders)
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-kd-personalise]").forEach(setPreviewFont);
  });

  // Also handle Shopify's section re-render in theme editor
  document.addEventListener("shopify:section:load", function () {
    document.querySelectorAll("[data-kd-personalise]").forEach(setPreviewFont);
  });
})();

